import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { ApiOutlined, ToolOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/maintenance',
    name: 'maintenance',
    redirect: '/maintenance/equipment',
    component: Layout,
    meta: {
      title: 'Maintenance',
      icon: renderIcon(ToolOutlined),
      permissions: ['maintenance_equipment_read'],
      sort: 4.5, // after Equipment (4), before Purchasing (5)
    },
    children: [
      {
        path: 'equipment',
        name: 'maintenance_equipment',
        meta: {
          title: 'Equipment',
          prefix: 'Maintenance', // resource maintenance_equipment: vw_ / tbl_maintenance_equipment
          icon: renderIcon(ApiOutlined),
          permissions: ['maintenance_equipment_read'],
        },
        component: () => import('@/views/maintenance/equipment/index.vue'),
      },
    ],
  },
];

export default routes;
